import { ETargetPage, MainFiltersWidget } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { AddNewCardButton, AddNewCardButtonAB, ErrorMessageContainer } from './parts';
import { useExperimentByGroupName } from '../../hooks';
import { MY_HOME_BY_FLAT_NUMBER } from '../../constants/experiments';

interface IAddNewCardProps {
  buttonRef?: React.Ref<HTMLDivElement>;
}

export const AddNewCardContainer: React.FC<IAddNewCardProps> = ({ buttonRef }) => {
  const isExperimentGroupB = useExperimentByGroupName(MY_HOME_BY_FLAT_NUMBER, 'B');
  const CardButtonComponent = isExperimentGroupB ? AddNewCardButtonAB : AddNewCardButton;

  return (
    <>
      <MainFiltersWidget targetPage={ETargetPage.myHomePage} withRoomNumber={isExperimentGroupB} isMyHome={true} />
      <ErrorMessageContainer />
      <CardButtonComponent buttonRef={buttonRef} />
    </>
  );
};
